import { FC } from "react";
import OrderOptimizerRailyDetailsHiddenDetailsSummaryFooterComponent from "./summary-footer/order-optimizer-raily-details-hidden-details-summary-footer.component";
import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableComponent from "./center-tables/order-optimizer-raily-details-hidden-details-center-tables.component";
import OrderOptimizerRailyDetailsHiddenDetailsDriverSelectComponent from "./driver/order-optimizer-raily-details-hidden-details-driver-select.component";
import OrderOptimizerRailyDetailsHiddenDetailsDriver from "./driver/types/order-optimizer-raily-details-hidden-details-driver";
import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableComponent from "./heading-tables/order/order-optimizer-raily-details-hidden-details-heading-tables-order-table.component";
import OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableComponent from "./heading-tables/driver/order-optimizer-raily-details-hidden-details-heading-tables-driver-table.component";
import OrderOptimizerRailyDetailsItem from "../common/types/order-optimizer-raily-details-item";

type OrderOptimizerRailyDetailsHiddenDetailsProps = {
  optimizationId: string | undefined;
  detailsItem: OrderOptimizerRailyDetailsItem;
  onPotentialDriverChange: (
    driver: OrderOptimizerRailyDetailsHiddenDetailsDriver | null
  ) => void;
};

const OrderOptimizerRailyDetailsHiddenDetailsComponent: FC<
  OrderOptimizerRailyDetailsHiddenDetailsProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyDetailsTranslations();

  return (
    <>
      <div className="order_optimizer_raily_details_hidden_details">
        <div className="order_optimizer_raily_details_hidden_details__heading_section">
          <div className="order_optimizer_raily_details_hidden_details__heading_section__left">
            <div>
              <OrderOptimizerRailyDetailsHiddenDetailsDriverSelectComponent
                optimizationId={props.optimizationId}
                onPotentialDriverChange={props.onPotentialDriverChange}
              />
            </div>
          </div>
          <div className="order_optimizer_raily_details_hidden_details__heading_section__center">
            <h4 className="order_optimizer_raily_details_hidden_details_order__text">
              {translations.table.headingTables.headingOrdersLabel}
            </h4>
            <div className="order_optimizer_raily_details_hidden_details_order">
              <OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesOrderTableComponent
                detailsStepsHomeToStartItems={
                  props.detailsItem.steps.homeToStart
                }
              />
            </div>
          </div>
          <div className="order_optimizer_raily_details_hidden_details__heading_section__right">
            <h4 className="order_optimizer_raily_details_hidden_details_order__text">
              {translations.table.headingTables.headingDrierLabel}
            </h4>
            <div className="order_optimizer_raily_details_hidden_details_driver">
              <OrderOptimizerRailyDetailsHiddenDetailsHeadingTablesDriverTableComponent
                detailsStepsHomeToStartItem={
                  props.detailsItem.steps.homeToStart
                }
              />
            </div>
          </div>
        </div>
        <div className="order_optimizer_raily_details_hidden_details__center_section">
          <OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableComponent
            orders={props.detailsItem.orders}
            ordersSteps={props.detailsItem.steps.orders}
            driver={props.detailsItem.driver}
          />
        </div>
        <div className="order_optimizer_raily_details_hidden_details__lower_section">
          <OrderOptimizerRailyDetailsHiddenDetailsSummaryFooterComponent
            detailsItem={props.detailsItem}
          />
        </div>
      </div>
    </>
  );
};

export default OrderOptimizerRailyDetailsHiddenDetailsComponent;
